import { camelCase } from '@cc-shopping/utils/string/camelCase';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverRewardRate = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverRewardRate) return null;
  return {
    id: camelCase(marketplaceEntity.driverRewardRate.label),
    label: marketplaceEntity.driverRewardRate.label,
    value: marketplaceEntity.driverRewardRate.value,
    description: marketplaceEntity.driverRewardRate.description,
    labelTooltip: undefined,
    valueTooltip: marketplaceEntity.driverRewardRate.valueTooltip,
    valueTooltipHasHtml: false,
  };
};
